import React from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import '../../css/common/KeyList.css'

type TOverlayTriggerProps = {
  tooltipId: string
  tooltipVal: string | null
  tooltipChild: JSX.Element
}

const TOverlayTrigger = ({
  tooltipId,
  tooltipVal,
  tooltipChild,
}: TOverlayTriggerProps) => {
  return tooltipVal == null ? (
    <td></td>
  ) : (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip className="responsive-font" id={tooltipId}>
          {tooltipVal}
        </Tooltip>
      }
    >
      {tooltipChild}
    </OverlayTrigger>
  )
}

export default TOverlayTrigger
